import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {AppMenuItem} from '../interfaces/menu-config-interface';
import {AppVersionService} from '../../core/services/app-version.service';

@Injectable({ providedIn: 'root' })
export class MenuConfigService {

  private http = inject(HttpClient);
  private versionService = inject(AppVersionService);
  loadMenu() {
    return this.http.get<AppMenuItem[]>(`config/menu.json?v=${this.versionService.version}`);
  }
}
